import { useAuth } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';
import { Link, Navigate } from 'react-router-dom';

import { getFallbackURL } from '@/lib/route';

export const FallbackPage = () => {
  // custom hooks
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Loader2 className="size-4 animate-spin" />
      </div>
    );
  }

  if (isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-6">
      <h1 className="as-h1 text-9xl font-bold">404</h1>
      <h2 className="as-h2 text-2xl">Page Not Found</h2>
      <p className="text-muted-foreground">
        The page you are looking for doesn't exist or has been moved.
      </p>
      <Link
        to={getFallbackURL()}
        className="text-brand-700 hover:text-brand-800 hover:underline"
      >
        Go back home
      </Link>
    </div>
  );
};
